var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"8070","height":"768","viewBox":"0 0 8070 768","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}},[_c('path',{attrs:{"d":"M0 0H8070V768H0V0Z M0 762.394V556.831C2499.42 960.215 5688.44 767.501 8070 0V762.394V768H0V762.394Z","fill":"currentColor","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }